import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.split.js";
import _typeof from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/typeof";
import { parse } from './cookie';
/**
 * 去字符串前后空格
 * @returns {String}
 */

function trim() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
}
/**
 * 哈希time33算法
 * @param {String} key
 * @returns hash code
 */


function time33(key) {
  for (var i = 0, len = key.length, hash = 5381; i < len; ++i) {
    hash += (hash << 5) + key.charAt(i).charCodeAt(0);
  }

  return hash & 0x7fffffff;
}

export function getToken() {
  var skey = getSkey();
  var token = skey ? time33(skey) : '';
  return token;
}
export function getUin() {
  if (getSkey() === '') {
    return 0;
  }

  var cookies = parse(document.cookie);
  var uin = cookies.uin ? parseInt(cookies.uin.replace(/^o0*/g, ''), 10) : 0;

  if (!uin || uin <= 10000) {
    uin = cookies.luin ? parseInt(cookies.luin.replace(/^o0*/g, ''), 10) : 0;

    if (!uin || uin <= 10000) {
      return 0;
    }
  }

  return uin;
}
export function getSkey() {
  var cookies = parse(document.cookie);
  var skey = trim(cookies.skey);
  return skey || trim(cookies.lskey);
}
var oo = {};
var toString = oo.toString;
var hasOwn = oo.hasOwnProperty;
var fnToString = hasOwn.toString;
export function isPlainObject(obj) {
  if (!obj || toString.call(obj) !== '[object Object]') {
    return false;
  }

  var proto = Object.getPrototypeOf(obj);

  if (!proto) {
    return true;
  }

  var _constructor = hasOwn.call(proto, 'constructor') && proto.constructor;

  return typeof _constructor === 'function' && fnToString.call(_constructor) === fnToString.call(Object);
} // 对比 app 版本

export function compareVersion(versionA, versionB) {
  var verA = versionA.split('.');
  var verB = versionB.split('.');
  var len = Math.min(verA.length, verB.length);
  var result = -1;

  for (var i = 0; i < len; i++) {
    if (verA[i] > verB[i]) {
      result = 1;
    } else if (verA[i] < verB[i]) {
      result = -1;
    } else {
      result = 0;
    }
  }

  return result;
}
export var isArray = Array.isArray || function (object) {
  return object instanceof Array;
};
export function assign(target, source, deep) {
  for (var key in source) {
    if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
      if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
        target[key] = {};
      }

      if (isArray(source[key]) && !isArray(target[key])) {
        target[key] = [];
      }

      assign(target[key], source[key], deep);
    } else if (source[key] !== undefined) {
      target[key] = source[key];
    }
  }

  return target;
}

function _toString(v) {
  return Object.prototype.toString.call(v);
}

function _isObject(v) {
  return _toString(v) === '[object Object]';
}

function _trim(v) {
  if (_toString(v) !== '[object String]') {
    return v;
  }

  return v.replace(/^\s+|\s+$/g, '');
}

export function buildUrl(url, params, useEncode) {
  var queryStr = '';

  if (!url) {
    throw new Error('[util.url.buildUrl]url is required');
  }

  if (!params || params === null) {
    return url;
  }

  queryStr = buildParams(params, useEncode);

  if (!queryStr || !queryStr.length) {
    return url;
  }

  if (url.indexOf('//') === 0) url = window.location.protocol + url;
  return [url, url.indexOf('?') > -1 ? '&' : '?', queryStr].join('');
}
export function buildParams(params, useEncode, strictMode) {
  var k, v, query;
  var r = [];

  for (k in params) {
    v = params[k];
    query = _buildParam(k, v, useEncode, strictMode);

    if (query != null && query !== '') {
      r.push(query);
    }
  }

  return r.join('&');
}

function _buildParam(k, v, useEncode) {
  var strictMode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var type = _typeof(v);

  var prop;
  var i = 0;
  var len;
  var r = []; // 默认是严格模式，过滤空值

  if (v === '' && strictMode) {
    return '';
  }

  if (type === 'number' || type === 'string' || type === 'boolean') {
    return [k, useEncode ? encodeURIComponent(v) : v].join('=');
  }

  if (_isObject(v)) {
    for (prop in v) {
      r.push(_buildParam([k, '[', prop, ']'].join(''), v[prop], useEncode, strictMode));
    }
  } else if (Array.isArray(v)) {
    for (len = v.length; i < len; i++) {
      r.push(_buildParam([k, '[', i, ']'].join(''), v[i], useEncode, strictMode));
    }
  } // 过滤null, undefined, ''


  r = r.filter(function (item) {
    return item != null && _trim(item) !== '';
  });
  return r.length ? r.join('&') : '';
}